import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { WaterState } from '../../models/water';

interface InitialState {
  isWaterInfoModalOpen: boolean;
  selectedState: WaterState | null;
  selectedLayerId: string | null;
}

type WaterInfoModalOpenRequest = {
  selectedState: WaterState;
  selectedLayerId: string;
};

const initialState: InitialState = {
  isWaterInfoModalOpen: false,
  selectedLayerId: null,
  selectedState: null,
};

const waterInfoSlice = createSlice({
  initialState,
  name: 'waterInfo',
  reducers: {
    clearModal: (state) => {
      state.isWaterInfoModalOpen = initialState.isWaterInfoModalOpen;
      state.selectedState = null;
    },
    closeWaterInfoModal: (state) => {
      state.isWaterInfoModalOpen = false;
      state.selectedState = null;
      state.selectedLayerId = null;
    },
    openWaterInfoModal: (
      state,
      action: PayloadAction<WaterInfoModalOpenRequest>
    ) => {
      state.selectedState = action.payload.selectedState as any; // TODO: why does this error???
      state.selectedLayerId = action.payload.selectedLayerId;
      state.isWaterInfoModalOpen = true;
    },
  },
});

export const { clearModal, openWaterInfoModal, closeWaterInfoModal } =
  waterInfoSlice.actions;

export default waterInfoSlice.reducer;
